import { render, staticRenderFns } from "./issueReply.vue?vue&type=template&id=81959c30&scoped=true&"
import script from "./issueReply.vue?vue&type=script&lang=ts&"
export * from "./issueReply.vue?vue&type=script&lang=ts&"
import style0 from "./issueReply.vue?vue&type=style&index=0&id=81959c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81959c30",
  null
  
)

export default component.exports